__turbopack_context__.v({
  "container": "FundraisingEventDescription-module__tmD1NW__container",
  "descriptionContainer": "FundraisingEventDescription-module__tmD1NW__descriptionContainer",
  "image": "FundraisingEventDescription-module__tmD1NW__image",
  "managerContainer": "FundraisingEventDescription-module__tmD1NW__managerContainer",
  "title": "FundraisingEventDescription-module__tmD1NW__title",
});
